module.exports = __webpack_public_path__ + "img/5.c25013a5.png";